import { defineMessages } from 'react-intl';

export const messages: {
	emailLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inboxLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	forwardedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalPersonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timestampLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	emailLabel: {
		id: 'search-federated-result.email.label',
		defaultMessage: 'Email',
		description: 'Label for email search results',
	},
	inboxLabel: {
		id: 'search-federated-result.inbox.label',
		defaultMessage: 'Inbox',
		description: 'Label for inbox',
	},
	sentLabel: {
		id: 'search-federated-result.sent.label',
		defaultMessage: '{person} sent',
		description: 'Verb label for sent emails',
	},
	forwardedLabel: {
		id: 'search-federated-result.forwarded.label',
		defaultMessage: '{person} forwarded',
		description: 'Label for forwarded emails',
	},
	externalPersonLabel: {
		id: 'search-federated-result.external-person.label',
		defaultMessage: 'External person',
		description: 'Label for external person in the search result title',
	},
	timestampLabel: {
		id: 'search-federated-result.timestamp.label',
		// eslint-disable-next-line @atlassian/i18n/no-useless-message
		defaultMessage: '{formattedDate}',
		description: 'Label for the timestamp to include only the date',
	},
});
